import { useEffect, useRef } from 'react'

export function useOnBeforeUnload(onBeforeUnload: () => void) {
  const fired = useRef(false)

  useEffect(() => {
    const handler = () => {
      if (fired.current) return
      fired.current = true
      window.setTimeout(() => {
        fired.current = false
      }, 0)
      onBeforeUnload()
    }

    const handlePageShow = () => {
      fired.current = false
    }

    window.addEventListener('beforeunload', handler)
    window.addEventListener('pagehide', handler)
    window.addEventListener('pageshow', handlePageShow)

    return () => {
      window.removeEventListener('beforeunload', handler)
      window.removeEventListener('pagehide', handler)
      window.removeEventListener('pageshow', handlePageShow)
    }
  }, [onBeforeUnload])
}
